import { render, staticRenderFns } from "./PaymentBoleto.vue?vue&type=template&id=58fdf854&"
import script from "./PaymentBoleto.vue?vue&type=script&lang=js&"
export * from "./PaymentBoleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PaymentBoleto.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58fdf854')) {
      api.createRecord('58fdf854', component.options)
    } else {
      api.reload('58fdf854', component.options)
    }
    module.hot.accept("./PaymentBoleto.vue?vue&type=template&id=58fdf854&", function () {
      api.rerender('58fdf854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentData/PaymentBoleto.vue"
export default component.exports